import React, { createContext, useContext } from 'react';
import { ReadOnlyProvider } from '@spark';
import { useAuth } from '@/features/auth';
import usePlatformUpgrader from '../hooks/usePlatformUpgrader';

export const PAUSED_DURING_UPDATE = 'Paused during the update';

const PlatformUpgraderContext = createContext(null);

/**
 * Polls the upgrader once for the whole app. The top bar reads the state, and
 * while an update runs every action that opted into read-only mode is paused.
 */
export function PlatformUpgraderProvider({ children }) {
    const { isAuthEnabled, user, role } = useAuth();
    const upgrader = usePlatformUpgrader({
        enabled: !isAuthEnabled || (Boolean(user) && role !== 'Unassigned'),
        isAdmin: !isAuthEnabled || role === 'Admin',
    });
    return (
        <PlatformUpgraderContext.Provider value={upgrader}>
            <ReadOnlyProvider readOnly={upgrader.readOnly} reason={PAUSED_DURING_UPDATE}>
                {children}
            </ReadOnlyProvider>
        </PlatformUpgraderContext.Provider>
    );
}

export function usePlatformUpgraderState() {
    return useContext(PlatformUpgraderContext);
}
